// Compatibility surface for app.ts (audio §7.1): the sound engine now lives in audio/engine.ts
// (WebAudio engine, pre-rendered voices, caps and guards), the sounds in audio/recipes.ts and
// the trigger rules in audio/triggers.ts. `Sfx` is the engine (re-exported under its old name); `SFX`, `SFX_NAMES` and
// `sfxAllowed` keep their old meaning (slot table, slot names, settings gate).
//
// Implementer: client-audio (lane A). Consumer: app.ts.

import { type AudioEngineOptions, type AudioSettings, GUARDS, soundAllowed } from './engine.js';
import { RECIPES, SOUND_SLOTS, type SoundSlot } from './recipes.js';

export {
  AudioEngine,
  AudioEngine as Sfx,
  type AudioEngineOptions,
  type AudioSettings,
} from './engine.js';
export { attachAudioTriggers } from './triggers.js';

export type SfxName = SoundSlot;
export type SfxOptions = AudioEngineOptions;

/** Every slot with its group, length and peak (audio §4). */
export const SFX = RECIPES;
export const SFX_NAMES: readonly SfxName[] = SOUND_SLOTS;

/** Minimum gap between two `eat` starts (audio §5; was 80 ms before the parity pass). */
export const EAT_MIN_GAP_MS: number = GUARDS.eat?.minGapMs ?? 30;

/** Whether `name` may play under `settings` (group switch and a non-zero volume). */
export function sfxAllowed(name: SfxName, settings: AudioSettings): boolean {
  return soundAllowed(name, settings);
}
